import { UseFormRegister, Control, FieldErrors } from "react-hook-form";
import { z } from "zod";
import { InvoiceForm } from "./InvoiceForm";
import { InvoiceItemSchema } from "./InvoiceFormContainer";

type InvoiceFormValues = {
    invoices: z.infer<typeof InvoiceItemSchema>[];
};

type InvoiceSliderContainerProps = {
    register: UseFormRegister<InvoiceFormValues>;
    fields: Record<"id", string>[];
    remove: (index: number) => void;
    control: Control<InvoiceFormValues>;
    errors: FieldErrors<InvoiceFormValues>;
};

/**
 * Container component that manages multiple invoice form sliders
 * 
 * This component acts as a wrapper for multiple InvoiceForm components, handling the
 * form array functionality and passing down necessary props to each individual form.
 * 
 * @component
 * @param {UseFormRegister<InvoiceFormValues>} register - React Hook Form register function
 * @param {Record<"id", string>[]} fields - Array of form fields from useFieldArray
 * @param {(index: number) => void} remove - Function to remove an invoice form at given index
 * @param {Control<InvoiceFormValues>} control - React Hook Form control object
 * @param {FieldErrors<InvoiceFormValues>} errors - Form validation errors
 * 
 */

export function InvoiceSliderContainer({ 
    register, 
    fields, 
    remove, 
    errors,
    control
}: InvoiceSliderContainerProps) {
    return (
        <div>
            {fields.map((field, index) => (
                <InvoiceForm 
                    key={field.id} 
                    register={register} 
                    index={index}
                    onRemoveInvoice={() => remove(index)} 
                    control={control}
                    errors={errors}
                />
            ))}
        </div>
    )
}
